// src/encounter/lib/open-medication-reconciliation.ts
// Left-rail target §3 / §7.6: the rail's "Reconcile medications" opens the existing reconciliation card (#916, PROD-1653). Since #929
// the nurse's pre-visit is Antonin's PreVisitPage (nurse-previsit-template.tsx), which draws that card as its "Medication
// reconciliation" PreEncounterCard (a section whose accessible name is the title). It brings that card into view and moves focus
// into it; it adds nothing and writes nothing. False when the card is not on the page (nothing to open).
export const MEDICATION_RECONCILIATION_LABEL = 'Medication reconciliation';

/** Does this pre-visit page draw the reconciliation card? The ONE rule both the page (encounter-workflow.tsx, which mounts the nurse's
 *  template) and the rail (which offers Reconcile only where there is a card to open) read: the Signal pre-visit is on, the role is
 *  the nurse and the page has the nurse's template host. No other page mounts the #916 card today (the physician's pre-visit and
 *  every started visit have none), so the rail offers no Reconcile there: an action with nothing to open is never drawn. */
export function previsitDrawsReconciliation(p: { signalPrevisit: boolean; encounterRole?: string; hasNurseTemplate: boolean }): boolean {
  return p.signalPrevisit && p.encounterRole === 'nurse' && p.hasNurseTemplate;
}

export function openMedicationReconciliation(root: ParentNode = document): boolean {
  const card = root.querySelector<HTMLElement>(`[aria-label="${MEDICATION_RECONCILIATION_LABEL}"]`);
  if (!card) return false;
  card.scrollIntoView?.({ block: 'start', behavior: 'smooth' });
  const first = card.querySelector<HTMLElement>('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  (first ?? card).focus?.({ preventScroll: true });
  return true;
}
